<template>
  <div class="page-container">
    <div class="status-section">
      <div class="status-text">
        <span class="indicator-bar"></span>
        <text v-if="countdownText !== '已过期'">
          {{ getStatusText(orderDetail.status) }}</text
        >
        <!-- 倒计时待付款显示 -->
        <text
          class="time"
          v-if="orderDetail.status == 0 && orderDetail.order_type == 3"
          >{{ countdownText }}</text
        >
      </div>
      <div class="delivery-toggle">
        <div
          class="toggle-item"
          :class="{ active: orderDetail.pickup_method === 1 }"
        >
          门店自提
        </div>
        <div
          class="toggle-item"
          :class="{ active: orderDetail.pickup_method === 2 }"
        >
          快递发货
        </div>
      </div>
    </div>
    <div class="scroll-content">
      <!-- 客户信息卡片 -->
      <div class="info-card customer-card">
        <div class="card-row header-row">
          <div class="buyer-name">
            买家姓名：{{ orderDetail.recipient_name }}
          </div>
          <button
            class="contact-btn"
            @click="callPhone(orderDetail.recipient_phone)"
          >
            <span class="icon">
              <img :src="phoneIco" alt="联系客户图标" />
            </span>
            联系客户
          </button>
        </div>
        <div class="card-row">
          买家手机号：{{ orderDetail.recipient_phone }}
        </div>
        <div
          class="card-row address-row"
          v-if="orderDetail.pickup_method === 2"
        >
          <span class="label">收货地址：</span>
          <span class="value">{{ orderDetail.recipient_address }}</span>
        </div>
      </div>

      <!-- 商品卡片 -->
      <div class="info-card product-card">
        <div
          class="product-content"
          v-for="(item, index) in orderDetail.products"
          :key="index"
        >
          <img
            :src="comapi.getImageUrl(item.cover_image)"
            class="product-img"
            alt="商品图片"
          />
          <div class="product-info">
            <div class="p_name_con">
              <div class="p-title">
                {{ item.product_name }}({{ item.spec_name }})
              </div>
              <span class="count">x{{ item.num }}</span>
            </div>
            <div class="p_specs_con">
              <span>规格：{{ item.unit }}</span>
              <span>¥{{ item.user_price }}</span>
            </div>
            <div class="p_price_con">
              <span>赠送{{ item.points_reward }}积分</span>
              <div class="line"></div>
              <span>抵扣{{ item.points_deduction }}积分</span>
            </div>
            <div class="p-price-row">¥{{ item.pay_amount }}</div>
          </div>
        </div>
      </div>
      <!-- 订单基础信息 -->
      <div class="info-card base-info-card">
        <div class="info-line">
          <span class="label">订单编号：</span>
          <span class="value">{{ orderDetail.order_uuid }}</span>
          <button class="copy-btn" @click="copyText(orderDetail.order_uuid)">
            复制
          </button>
        </div>
        <div class="info-line">
          <span class="label">下单时间：</span>
          <span class="value">{{ orderDetail.create_time }}</span>
        </div>
        <div class="info-line">
          <span class="label">订单备注：</span>
          <span class="value">{{ orderDetail.remark || "- -" }}</span>
        </div>
      </div>
      <!-- 优惠券/积分 -->
      <div class="info-card coupon-card-container">
        <div class="coupon-card item-start">
          <div class="left_title">
            <img
              src="/src/assets/img/icons/icon50.png"
              class="icon_points"
              mode="aspectFill"
            />
            <span class="points">优惠券</span>
          </div>
          <div class="right_coupon item-start">
            <span>{{ orderDetail.coupon_usage_note || "无" }}</span>

            <span v-if="orderDetail.status === 5" class="returnTips">
              [已退回]
            </span>
          </div>
        </div>
        <div class="coupon-card">
          <div class="left_title">
            <span class="points">积分抵现</span>
          </div>
          <div class="right_coupon">
            <span
              >{{ orderDetail.total_points_deduction }}分 共抵扣{{
                orderDetail.total_points_amount
              }}元</span
            >
          </div>
        </div>
      </div>
      <!-- 价格明细 -->
      <div class="info-card price-card">
        <div class="price-line">
          <span>商品金额</span>
          <span class="amount">¥{{ orderDetail.total_money }}</span>
        </div>
        <div class="price-line">
          <span>运 费</span>
          <span class="amount">¥{{ orderDetail.deliver_amount }}</span>
        </div>
        <div class="price-line">
          <span>共计优惠</span>
          <span class="amount">-¥{{ orderDetail.total_discount_amount }}</span>
        </div>
        <div class="total-line">
          实付金额：<span class="big-price">¥{{ orderDetail.pay_amount }}</span>
        </div>
      </div>
      <div class="info-card scroll-card">
        <div class="left">
          <img
            src="/src/assets/img/icons/icon51.png"
            class="icon_points"
            mode="aspectFill"
          />
          <span>累计赠送积分</span>
        </div>
        <span>
          {{ orderDetail.total_points_reward }}分
          <span class="title_tip_ref" v-if="orderDetail.status == 5"
            >积分已退回</span
          >
        </span>
      </div>
      <!-- 退款状态显示申请时间，退款成功显示退款时间 -->
      <div
        class="info-card base-info-card"
        v-if="orderDetail.status === 3 || orderDetail.status === 5"
      >
        <div class="info-line">
          <span class="label">申请理由：</span>
          <span class="value">{{ orderDetail.return_remark || "- -" }}</span>
        </div>
        <div class="info-line">
          <span class="label">申请时间：</span>
          <span class="value">{{ orderDetail.return_apply_time }}</span>
        </div>
      </div>
      <div
        class="info-card pay_qrcod"
        v-if="orderDetail.order_type == 3 && orderDetail.status == 0"
      >
        <div class="qrcod_butn" v-if="!isshowqrcod" @click="handleGetPayLink">
          点击获取支付码
        </div>
        <img
          v-if="isshowqrcod"
          :src="comapi.getImageUrl(jspay_info.pay_qrcode_url)"
          class="qrcode_img"
          mode="aspectFill"
        />
        <text class="title_tip">请客户使用微信/支付宝扫码支付</text>
      </div>
      <div
        class="info-card scroll-card"
        v-if="orderDetail.order_type == 3 && orderDetail.status == 0"
      >
        <div class="left">
          <img
            src="/src/assets/img/icons/icon52.png"
            class="icon_points"
            mode="aspectFill"
          />
          <span>代付</span>
        </div>
        <div class="right_payurl" @click="sendpayurl(jspay_info.jspay_url)">
          发送支付链接
        </div>
      </div>
    </div>
    <div
      class="bottom-action-bar"
      v-if="orderDetail.status == 0 && orderDetail.order_type == 3"
    >
      <button
        class="btn btn-default"
        @click="canceluserOrder(orderDetail.order_uuid)"
      >
        取消订单
      </button>
      <button
        class="btn btn-primary"
        @click="confirmPay(orderDetail.order_uuid)"
      >
        客户已现金支付
      </button>
    </div>
    <div class="bottom-action-bar" v-if="orderDetail.status == 1">
      <button
        class="btn btn-default"
        @click="
          DialogRemark = true;
          DialogTitle = '退单退款';
        "
      >
        退单退款
      </button>
      <button
        class="btn btn-default"
        @click="printorder(orderDetail.order_uuid)"
      >
        打印小票
      </button>
      <button
        class="btn btn-primary"
        @click="goShipment(orderDetail.order_uuid)"
        v-if="orderDetail.pickup_method == 2"
      >
        直接发货
      </button>
      <button
        class="btn btn-primary"
        @click="goVerify(orderDetail)"
        v-if="orderDetail.pickup_method == 1"
      >
        去核销
      </button>
    </div>
    <div class="bottom-action-bar" v-if="orderDetail.status == 2">
      <button
        class="btn btn-default"
        @click="
          DialogRemark = true;
          DialogTitle = '退货退款';
        "
      >
        退货退款
      </button>

      <button
        class="btn btn-primary"
        @click="goVerify(orderDetail)"
        v-if="orderDetail.pickup_method == 1"
      >
        去核销
      </button>
    </div>
    <div class="bottom-action-bar" v-if="orderDetail.status == 3">
      <button
        class="btn btn-default"
        @click="
          DialogRemark = true;
          DialogTitle = '驳回退款';
        "
      >
        驳回
      </button>
      <button
        class="btn btn-primary"
        @click="confirmRefund(orderDetail.order_uuid)"
      >
        确认退款
      </button>
    </div>
    <div class="bottom-action-bar" v-if="orderDetail.status == 4">
      <button
        class="btn btn-default"
        @click="
          DialogRemark = true;
          DialogTitle = '退货退款';
        "
      >
        退货退款
      </button>
      <button
        class="btn btn-default"
        @click="printorder(orderDetail.order_uuid)"
      >
        打印小票
      </button>
    </div>
    <van-dialog
      v-model:show="DialogRemark"
      :title="DialogTitle"
      show-cancel-button
      confirm-text="确认"
      @confirm="rejectRefund(orderDetail.order_uuid)"
    >
      <van-field
        v-model="RemarkValue"
        rows="2"
        autosize
        type="textarea"
        maxlength="50"
        placeholder="请输入原因"
        show-word-limit
      />
    </van-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import comapi from "@/utils/api/com";
import storeapi from "@/utils/api/store";
import { showToast, showSuccessToast, showConfirmDialog } from "vant";
import phoneIco from "@/assets/img/icons/phoneicon.png";
import { useRouter, useRoute } from "vue-router";
import authApi from "@/utils/api/auth";
import * as ww from "@wecom/jssdk";

const router = useRouter();
const route = useRoute();

const order_uuid = route.query.order_uuid || "";
const countdownText = ref("00:00:00"); //状态文本
const countdownTimer = ref(null); //倒计时定时器
const orderDetail = ref([]);
const jspay_info = ref({});
const isshowqrcod = ref(false);
const DialogRemark = ref(false);
const DialogTitle = ref("");
const RemarkValue = ref("");

let payStatusTimer = null;

// --- 方法 ---
const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    showToast("复制成功");
  } catch (err) {
    console.error("复制失败:", err);
    showToast("复制失败，请手动复制");
  }
};
const callPhone = (phoneNumber) => {
  // 调用系统拨打电话功能
  window.location.href = `tel:${phoneNumber}`;
};
onMounted(() => {
  getorderdetail();
});
onUnmounted(() => {
  clearCountdown();
  if (payStatusTimer) {
    clearInterval(payStatusTimer);
    payStatusTimer = null;
  }
});

//发送支付链接给好友
const sendpayurl = (payurl) => {
  ww.shareAppMessage({
    title: "支付链接",
    desc: "点击链接进行支付",
    link: payurl,
    imgUrl:
      "https://res.mail.qq.com/node/ww/wwmng/style/images/index_share_logo$13c64306.png",
  });
};
// 更新倒计时显示
const updateCountdown = () => {
  try {
    // 解析订单创建时间，处理可能的格式问题
    let createTimeStr = orderDetail.value.create_time;
    // 替换可能的多个空格为单个空格，确保格式正确
    createTimeStr = createTimeStr.replace(/\s+/g, " ");
    // 直接创建Date对象并添加30分钟
    let createTime = new Date(createTimeStr);
    if (isNaN(createTime.getTime())) {
      countdownText.value = "已过期";
      return;
    }
    createTime.setMinutes(createTime.getMinutes() + 10);
    let now = new Date();
    // 直接计算时间差，避免不必要的字符串转换
    let diff = createTime - now;
    if (diff <= 0) {
      countdownText.value = "已过期";
      // 倒计时结束，清除定时器
      clearCountdown();
      return;
    }
    // 计算时分秒
    let h = Math.floor(diff / (1000 * 60 * 60));
    let m = Math.floor(diff / (1000 * 60)) % 60;
    let s = Math.floor(diff / 1000) % 60;
    // 补零并确保为数字
    h = h < 10 ? "0" + h : h;
    m = m < 10 ? "0" + m : m;
    s = s < 10 ? "0" + s : s;
    countdownText.value = `${h}:${m}:${s}`;
  } catch (error) {
    console.error("倒计时计算错误:", error);
    countdownText.value = "已过期";
  }
};
// 清除倒计时定时器
const clearCountdown = () => {
  if (countdownTimer.value) {
    clearInterval(countdownTimer.value);
    countdownTimer.value = null;
  }
};
//去核销
const goVerify = (data) => {
  localStorage.setItem("orderresult", JSON.stringify([data.order_uuid]));
  router.push({
    path: "/orderwrite",
    query: {
      user_uuid: data.user_uuid,
    },
  });
};
//去发货
const goShipment = (order_uuid) => {
  router.push({
    path: "/ordershipment",
    query: {
      order_uuid: order_uuid,
    },
  });
};
//确认订单已支付
const confirmPay = (order_uuid) => {
  showConfirmDialog({
    title: "确认订单已支付",
    message: "是否确认当前订单已支付？",
  })
    .then(() => {
      storeapi
        .confirmPay({
          order_uuid: order_uuid,
        })
        .then((res) => {
          if (res.code == 200) {
            showToast("确认成功");
            getorderdetail();
          }
        });
    })
    .catch(() => {
      // on cancel
    });
};
// 点击获取支付码
function handleGetPayLink() {
  isshowqrcod.value = true;

  payStatusTimer = setInterval(() => {
    storeapi
      ._getPayStatus({ order_uuid: orderDetail.value?.order_uuid })
      .then((res) => {
        console.log(res);
        if (res?.data && res?.data !== orderDetail.value?.status) {
          showSuccessToast("支付成功!");
          getorderdetail();

          clearInterval(payStatusTimer);
          payStatusTimer = null;
        }
      });
  }, 1000);
}
//取消订单
const canceluserOrder = (order_uuid) => {
  showConfirmDialog({
    title: "取消订单",
    message: "确认要取消订单？",
  })
    .then(() => {
      storeapi
        .canceluserOrder({
          order_uuid: order_uuid,
        })
        .then((res) => {
          if (res.code == 200) {
            showToast("取消成功");
            getorderdetail();
          }
        });
    })
    .catch(() => {
      // on cancel
    });
};
//驳回退款
const rejectRefund = (order_uuid) => {
  // 检查是否有退款备注
  if (!RemarkValue.value.trim()) {
    showToast("请输入原因");
    return;
  }
  let departmentdata = localStorage.getItem("departmentdata");
  departmentdata = JSON.parse(departmentdata);
  if (DialogTitle.value === "退单退款") {
    showConfirmDialog({
      title: "退单退款",
      message: "确认要退单退款？",
    }).then(() => {
      storeapi
        .refundOrder({
          shop_uuid: departmentdata.department_uuid,
          order_uuid: order_uuid,
          remark: RemarkValue.value,
        })
        .then((res) => {
          if (res.code == 200) {
            showToast("退单退款成功");
            // 刷新订单详情
            getorderdetail();
          }
        });
    });
  }
  if (DialogTitle.value === "驳回退款") {
    showConfirmDialog({
      title: "驳回退款",
      message: "确认要驳回退款？",
    }).then(() => {
      storeapi
        .rejectRefund({
          order_uuid: order_uuid,
          remark: RemarkValue.value,
        })
        .then((res) => {
          if (res.code == 200) {
            showToast("驳回成功");
            // 刷新订单详情
            getorderdetail();
          }
        });
    });
  }
};
//打印小票
const printorder = (order_uuid) => {
  storeapi
    .printorder({
      order_uuid: order_uuid,
    })
    .then((res) => {
      if (res.code == 200) {
        showToast("打印成功");
      }
    });
};
//确认退款
const confirmRefund = (order_uuid) => {
  let departmentdata = localStorage.getItem("departmentdata");
  departmentdata = JSON.parse(departmentdata);
  storeapi
    .confirmRefund({
      shop_uuid: departmentdata.department_uuid,
      order_uuid: order_uuid,
    })
    .then((res) => {
      if (res.code == 200) {
        showToast("退款成功");
        // 刷新订单详情
        getorderdetail();
      }
    });
};
const getStatusText = (status) => {
  if (status == -1) {
    return "已取消";
  }
  const statusMap = {
    0: "待支付",
    1: "待发货/自提",
    2: "待收货",
    3: "退款中",
    4: "已完成",
    5: "已退款",
    "-1": "已取消",
  };
  return statusMap[status] || status;
};
// 启动倒计时定时器
const startCountdown = () => {
  // 立即计算一次倒计时
  updateCountdown();
  // 每秒更新一次
  countdownTimer.value = setInterval(() => {
    updateCountdown();
  }, 1000);
};
const getorderdetail = () => {
  storeapi
    .getuserorderdetail({
      order_uuid: order_uuid,
    })
    .then((res) => {
      if (res.code == 200) {
        orderDetail.value = res.data;
        if (res.data.status === 0 && res.data.order_type == 3) {
          // 启动倒计时定时器
          startCountdown();
          getpayurl();
        }
      }
    });
};
//获取支付连接
const getpayurl = () => {
  storeapi
    .generatePayCode({
      order_uuid: order_uuid,
    })
    .then((res) => {
      if (res.code == 200) {
        jspay_info.value = res.data;
        authApi.initWeWorkConfig();
      }
    });
};
</script>

<style lang="less" scoped>
.page-container {
  background-color: #f5f6fa;
  /* 背景灰 */
  min-height: 100vh;
  font-family:
    -apple-system, BlinkMacSystemFont, "PingFang SC", "Helvetica Neue", Arial,
    sans-serif;
  color: #333333;
  padding-bottom: 80px;
  overflow-y: auto;
}

// 1. 状态区域
.status-section {
  background-color: rgba(220, 187, 137, 0.15);
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .status-text {
    display: flex;
    align-items: center;
    font-size: 17px;
    font-weight: 600;
    color: #3c211f;

    .indicator-bar {
      width: 4px;
      height: 17px;
      background-color: #dcbb89;
      margin-right: 8px;
      border-radius: 2px;
    }
  }

  .delivery-toggle {
    display: flex;
    border: 1px solid #e6dace;
    border-radius: 2px;
    overflow: hidden;

    .toggle-item {
      padding: 6px 12px;
      font-size: 13px;
      color: #dcbb89;
      cursor: pointer;
      transition: all 0.2s;

      &.active {
        background-color: #dcbb89;
        color: #ffffff;
      }
    }
  }
}

// 2. 通用卡片样式
.scroll-content {
  padding: 10px;
}

.info-card {
  background: #ffffff;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 10px;
  font-size: 14px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
}

.scroll-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;
  color: #333;

  .title_tip_ref {
    font-size: 14px;
    color: #ff0000;
  }

  .left {
    display: flex;
    align-items: center;

    .icon_points {
      width: 23px;
      height: 23px;
      margin-right: 5px;
    }
  }

  .right_payurl {
    width: 122px;
    height: 36px;
    border-radius: 2px;
    border: 1px solid #ccc;
    font-size: 14px;
    color: #333;
    text-align: center;
    line-height: 36px;
  }
}

.pay_qrcod {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 19px;
  color: #333;
  font-weight: bold;

  .qrcod_butn {
    border: 0px solid #dcbb89;
    width: 149px;
    height: 36px;
    line-height: 36px;
    border-radius: 2px;
    background-color: #dcbb89;
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    text-align: center;
    margin-top: 10px;
    margin-bottom: 10px;
    transition: all 0.2s;

    &:hover {
      background-color: #dcbb89;
    }
  }

  .title_tip {
    font-size: 15px;
    color: #666;
    margin-bottom: 10px;
  }

  .qrcode_img {
    width: 150px;
    height: 150px;
    margin-bottom: 10px;
  }
}

.coupon-card-container {
  .coupon-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 13px;

    &.item-start {
      align-items: flex-start;
    }

    &:last-child {
      margin-bottom: 0;
    }

    .points {
      flex-shrink: 0;
    }

    .left_title {
      display: flex;
      align-items: center;

      .icon_points {
        width: 27px;
        height: 27px;
        margin-right: 4px;
      }

      .points {
        font-size: 15px;
        color: #666;
      }
    }

    .right_coupon {
      display: flex;
      align-items: center;
      font-size: 15px;
      color: #333;
      margin-left: 20px;

      &.item-start {
        align-items: flex-start;
      }

      .icon_coupon {
        width: 13px;
        height: 13px;
        margin-top: 1px;
        margin-left: 13px;
      }

      .returnTips {
        flex-shrink: 0;
        color: #e4393c;
        margin-left: 4px;
      }
    }
  }
}

// 客户信息卡片
.customer-card {
  .card-row {
    margin-bottom: 8px;
    line-height: 1.5;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .header-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    .buyer-name {
      font-size: 15px;
      font-weight: 400;
      display: flex;
      align-items: center;
    }

    .contact-btn {
      border: 1px solid #ff7123;
      background: #ffffff;
      color: #ff7123;
      padding: 4px 10px;
      border-radius: 4px;
      font-size: 13px;
      display: flex;
      align-items: center;
      margin-bottom: -8px;

      .icon {
        margin-right: 4px;
        width: 19px;
        height: 19px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .address-row {
    display: flex;

    .label {
      white-space: nowrap;
      color: #333;
    }

    .value {
      color: #333333;
    }
  }
}

// 商品卡片
.product-card {
  .product-content {
    display: flex;

    &:not(:last-child) {
      border-bottom: 1px solid #f5f5f5;
      padding-bottom: 12px;
      margin-bottom: 12px;
    }

    .product-img {
      width: 80px;
      height: 80px;
      border-radius: 6px;
      object-fit: cover;
      margin-right: 12px;
      background-color: #eeeeee;
    }

    .product-info {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .p_name_con {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .p-title {
          font-size: 15px;
          color: #333333;
          font-weight: 500;
        }

        .count {
          color: #999999;
          font-size: 14px;
        }
      }

      .p_specs_con {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #999999;
        font-size: 12px;
      }

      .p_price_con {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        color: #ff7123;
        font-size: 13px;

        .line {
          width: 1px;
          height: 13px;
          background-color: #ff7123;
          margin: 0 8px;
        }
      }

      .p-price-row {
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        color: #ff7123;
        font-size: 19px;
      }
    }
  }
}

// 基础信息卡片 (订单号等)
.base-info-card {
  .info-line {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }

    .label {
      color: #666666;
      margin-right: 5px;
    }

    .value {
      color: #333333;
      font-family: monospace;
      font-size: 14px;
    }

    .copy-btn {
      margin-left: 10px;
      background: #ffffff;
      border: 1px solid #cccccc;
      color: #666666;
      font-size: 11px;
      padding: 1px 6px;
      border-radius: 2px;
    }
  }
}

// 价格明细卡片
.price-card {
  .price-line {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    color: #666666;

    .amount {
      color: #333333;
      font-weight: 600;
    }
  }

  .total-line {
    text-align: right;
    margin-top: 15px;
    border-top: 1px solid #f5f5f5;
    padding-top: 12px;
    font-size: 14px;
    font-weight: 600;

    .big-price {
      color: #ff7123;
      font-size: 15px;
      margin-left: 5px;
    }
  }
}

// 3. 底部操作栏
.bottom-action-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #ffffff;
  padding: 10px 15px;
  display: flex;
  justify-content: flex-end;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  z-index: 100;
  max-width: 450px;
  margin: 0 auto;

  .btn {
    height: 38px;
    padding: 0 20px;
    border-radius: 4px;
    font-size: 14px;
    margin-left: 10px;
    border: none;
    cursor: pointer;
  }

  .btn-default {
    background: #ffffff;
    border: 1px solid #dddddd;
    color: #666666;
  }

  .btn-primary {
    background: #cfaa71;
    /* 按钮金 */
    color: #ffffff;
  }
}

// 适配底部栏在iPhone上的位置
@supports (padding-bottom: env(safe-area-inset-bottom)) {
  .bottom-action-bar {
    padding-bottom: calc(10px + env(safe-area-inset-bottom));
  }

  .page-container {
    padding-bottom: calc(80px + env(safe-area-inset-bottom));
  }
}
</style>
